import type { Feature } from '../types';
import { Region, FeatureName, ApplicationChannel } from '../config';

const casaFeature: Feature = {
  featureName: FeatureName.CASA,
  description: 'Casa Customer Service Integration',
  status: true,
  enabledAppChannels: [ApplicationChannel.WEB],
  enabledRegions: [Region.SG],
  payload: {},
};

export default casaFeature;
